import React ,{ Fragment }from 'react'
import Button from "../Buttons/Button";
import history from '../../containers/history'
export const ButtonCol = ({ disabled, saveFunc }) =>{
    return(
        <div class="col-md-12 profile-btn text-center">
            {!disabled && (
                <Fragment>
                    <Button
                        buttonType="save"
                        buttonName="Save"
                        onClick={saveFunc}
                    />
                    <Button
                        buttonType="cancel"
                        buttonName="cancel"
                        history={history}
                    />
                </Fragment>
            )}
        </div>
    ) 
}


// WEBPACK FOOTER //
// ./src/components/ButtonCol/index.js